import React, { useState, useEffect } from "react";
import { FaArrowLeft, FaFileExcel } from "react-icons/fa";
import NavBar from "../components/NavMenu";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";

const DetailQualityOfPasses = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const passedQuarters = location.state?.selectedQuarters || ["Q1 2025"];
  const [selectedQuarters] = useState(passedQuarters);
  const [studentData, setStudentData] = useState([]);

  const parseQuarterYear = (quarterStr) => {
    const [qtr, year] = quarterStr.split(" ");
    return { qtr: parseInt(qtr.replace("Q", "")), year: parseInt(year) };
  };

  useEffect(() => {
    const fetchData = async () => {
      const { qtr, year } = parseQuarterYear(selectedQuarters[0]);
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_API}/getQualityStudentByModule?qtr=${qtr}&year=${year}`
        );
        const current = res.data.current || [];
        setStudentData(current);
      } catch (err) {
        console.error("Failed to fetch quality of passes data", err);
      }
    };
    fetchData();
  }, [selectedQuarters]);

  const handlePrevious = () => {
    const extractedQuarter = parseInt(
      passedQuarters[0].split(" ")[0].replace("Q", "")
    );
    const extractedYear = parseInt(passedQuarters[0].split(" ")[1]);

    navigate("/home", {
      state: {
        view: "quality",
        selectedQuarter: extractedQuarter,
        selectedYear: extractedYear,
      },
    });
  };

  const groupedByCourse = studentData.reduce((acc, item) => {
    const course = item.course_code;
    if (!acc[course]) acc[course] = [];
    acc[course].push(item);
    return acc;
  }, {});

  return (
    <>
      <NavBar />
      <div
        style={{
          backgroundColor: "#373636",
          margin: 20,
          borderRadius: 10,
          padding: 30,
          minHeight: "calc(100vh - 80px)",
          color: "#fff",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            marginBottom: 20,
            flexWrap: "wrap",
            gap: 12,
          }}
        >
          <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
            <FaArrowLeft
              size={18}
              onClick={handlePrevious}
              style={{ cursor: "pointer" }}
            />
            <h4 style={{ margin: 0 }}>Quality Of Passes Details</h4>
            <span className="pill">{selectedQuarters[0]}</span>
          </div>
          <button
            onClick={() => console.log("Export to Excel")}
            className="excel-button"
          >
            <FaFileExcel size={18} /> Export to Excel
          </button>
        </div>

        {Object.entries(groupedByCourse)
          .sort(([a], [b]) => a.localeCompare(b))
          .map(([course_code, students], idx) => {
            const subjectSet = new Set();
            const groupedByStudent = {};

            students.forEach((item) => {
              subjectSet.add(item.subject_code);
              if (!groupedByStudent[item.student_id]) {
                groupedByStudent[item.student_id] = {
                  student_id: item.student_id,
                  name: item.name,
                  subjects: {},
                };
              }
              groupedByStudent[item.student_id].subjects[item.subject_code] = {
                mark: item.final_marks,
                grade: item.final_grade,
                gradeB: ["B", "A", "A+"].includes(item.final_grade) ? 1 : "",
              };
            });

            const subjects = Array.from(subjectSet).sort();
            const studentList = Object.values(groupedByStudent);

            // Calculate B+ counts, student count, and percentage for each subject
            const gradeBCountPerSubject = {};
            const studentCountPerSubject = {};
            const percentagePerSubject = {};

            subjects.forEach((subj) => {
              const bCount = students.filter(
                (s) =>
                  s.subject_code === subj &&
                  ["B", "A", "A+"].includes(s.final_grade)
              ).length;
              const totalCount = students.filter(
                (s) => s.subject_code === subj
              ).length;
              gradeBCountPerSubject[subj] = bCount;
              studentCountPerSubject[subj] = totalCount;
              percentagePerSubject[subj] =
                totalCount > 0
                  ? ((bCount / totalCount) * 100).toFixed(2)
                  : "0.00";
            });

            return (
              <div key={idx} style={{ marginBottom: 40 }}>
                <div
                  style={{
                    backgroundColor: "#111",
                    padding: "10px 16px",
                    borderRadius: 6,
                    fontWeight: "bold",
                    fontSize: 16,
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <span>{course_code}</span>
                  <span
                    style={{
                      backgroundColor: "#ffa726",
                      padding: "4px 10px",
                      borderRadius: "999px",
                      fontSize: 13,
                      fontWeight: 500,
                      color: "#000",
                      minWidth: 28,
                      textAlign: "center",
                    }}
                  >
                    {studentList.length}
                  </span>
                </div>

                <div style={{ overflowX: "auto" }}>
                  <table className="styled-table table-bordered">
                    <thead>
                      <tr>
                        <th style={thStyle}>S/No</th>
                        <th style={thStyle}>Name</th>
                        <th style={thStyle}>Student ID</th>
                        {subjects.map((subj) => (
                          <th key={subj} style={thStyle} colSpan={3}>
                            {subj}
                          </th>
                        ))}
                      </tr>
                      <tr>
                        <th style={thStyle}></th>
                        <th style={thStyle}></th>
                        <th style={thStyle}></th>
                        {subjects.map((subj) => (
                          <React.Fragment key={subj}>
                            <th style={thStyle}>Mark</th>
                            <th style={thStyle}>Grade</th>
                            <th style={{...thStyle, width: "8%"}}>Grade B and above</th>
                          </React.Fragment>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {studentList.map((student, sidx) => (
                        <tr
                          key={sidx}
                          style={{
                            backgroundColor:
                              sidx % 2 === 0 ? "#2b2b2b" : "#252525",
                          }}
                        >
                          <td style={tdStyle}>{sidx + 1}</td>
                          <td style={tdStyle}>{student.name}</td>
                          <td style={tdStyle}>{student.student_id}</td>
                          {subjects.map((subj) => {
                            const subjData = student.subjects[subj] || {};
                            return (
                              <React.Fragment key={`${subj}-${sidx}`}>
                                <td style={tdStyle}>{subjData.mark || ""}</td>
                                <td style={tdStyle}>{subjData.grade || ""}</td>
                                <td
                                  style={{
                                    ...tdStyle,
                                    background: "#45b39d",
                                    color: "#000",
                                  }}
                                >
                                  {subjData.gradeB || ""}
                                </td>
                              </React.Fragment>
                            );
                          })}
                        </tr>
                      ))}

                      {/* TOTAL Grade B+ PER SUBJECT */}
                      <tr
                        style={{
                          backgroundColor: "#1b1b1b",
                          fontWeight: "bold",
                        }}
                      >
                        <td style={tdStyle} colSpan={3} align="right">
                          Total Grade B and Above:
                        </td>
                        {subjects.map((subj) => (
                          <React.Fragment key={`bcount-${subj}`}>
                            <td style={tdStyle}></td>
                            <td style={tdStyle}></td>
                            <td style={tdStyle}>
                              {gradeBCountPerSubject[subj]}
                            </td>
                          </React.Fragment>
                        ))}
                      </tr>

                      <tr
                        style={{ backgroundColor: "#333", fontWeight: "bold" }}
                      >
                        <td style={tdStyle} colSpan={3} align="right">
                          {" "}
                          Percentage:{" "}
                          <span
                            style={{
                              backgroundColor: "#ffa726",
                              padding: "4px 10px",
                              borderRadius: "999px",
                              fontSize: 13,
                              fontWeight: 500,
                              color: "#000",
                              minWidth: 28,
                              textAlign: "center",
                            }}
                          >
                            Overall  {" "}
                            {(
                              subjects.reduce(
                                (acc, subj) =>
                                  acc + parseFloat(percentagePerSubject[subj]),
                                0
                              ) / subjects.length
                            ).toFixed(2)}{" "}
                            %
                          </span>
                        </td>
                        {subjects.map((subj) => (
                          <React.Fragment key={`percent-${subj}`}>
                            <td style={tdStyle}></td>
                            <td style={tdStyle}>
                              {studentCountPerSubject[subj]}
                            </td>
                            <td style={tdStyle}>
                              {percentagePerSubject[subj]}%
                            </td>
                          </React.Fragment>
                        ))}
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            );
          })}
      </div>
      <style>{`
        .pill {
          background: #444;
          padding: 6px 12px;
          border-radius: 8px;
          font-size: 14px;
          font-weight: 500;
        }
        .styled-table {
          width: 100%;
          border-collapse: collapse;
          background-color: #1f1f1f;
          border-radius: 6px;
          overflow: hidden;
        }
        .styled-table thead {
          background-color: #000;
        }
      `}</style>
    </>
  );
};

const thStyle = {
  padding: "12px 8px",
  fontWeight: "bold",
  fontSize: 14,
  color: "#fff",
  borderBottom: "1px solid #444",
  textAlign: "center",
};
const tdStyle = {
  padding: "10px 8px",
  color: "#ddd",
  fontSize: 13,
  textAlign: "center",
};

export default DetailQualityOfPasses;
